
/* eslint-disable-next-line */
import Swiper from 'swiper/bundle'; // NOSONAR
import SwiperExt from '../swiper';

const { feWp } = window;
const { addFilter } = feWp.hooks;

addFilter( 'b3rg_slider_library', 'b3rg/slider', () => {
  return SwiperExt;
} );

addFilter(
  'b3rg_slider_extend',
  'b3rg/slider',
  ( defaultSliderSettings, element ) => {
    // Change the selector class accordingly
    if ( element.closest( '.e-stn--awards-carousel' ) ) {
      // Modify the default settings from here
    }
    return defaultSliderSettings;
  } );
  